import { useCartStore, useProductStore } from '@src/hooks/useStore'
import { getRegionHandle } from '@src/utils/region'
import { isProductInRegion } from '@src/utils/product'
import React from 'react'
import QuantityInput from '../quantity-input'
import KlaviyoBackInStock from '../newsletter/back-in-stock'
import BuyWithPrime from '../buy-with-prime/buy-with-prime'
import AffirmPromotion from '../widgets/affirm-promotion'
import { formatPrice } from '@src/utils/products/pricing'

const AddToCart = ({ product, handleAddToCart, discountAmountFromCode }) => {
  const { 
    currentVariant,
    quantity, 
    setQuantity,
    addedCrossSellProducts,
    accumulatedPrice,
    accumulatedPriceRaw
  } = useProductStore(["currentVariant", "quantity", "setQuantity", "addedCrossSellProducts", "accumulatedPrice", "accumulatedPriceRaw"])
  
  const { loading } = useCartStore(["loading"])
  
  const { 
    atcLabel,
    watchlist
  } = currentVariant

  const [
    available,
    availableInRegion,
    isAvailableWithPrime,
    unavailableCrossSells
  ] = [
    currentVariant.availableForSale,
    isProductInRegion(product, currentVariant),
    currentVariant.isAvailableWithPrime,
    addedCrossSellProducts?.some(
      _var =>
        !_var.product.availableForSale || !_var.product.isAvailableInRegion
    )
  ]

  const showAddToCart = (available && !watchlist) || (getRegionHandle() !== "us" && !available)

  return (
    <div className="flex flex-col py-5 gap-2.5 md:gap-5 sticky bottom-0 bg-white z-[1]">
      {showAddToCart && (
        <div className="flex gap-2.5 md:gap-5">
          <QuantityInput
            currentQuantity={quantity}
            onUpdate={e => setQuantity(e)}
            sku={currentVariant.sku}
            minQuantity={1}
          />
          <button
            disabled={
              !available ||
              !availableInRegion ||
              unavailableCrossSells ||
              loading 
            }
            onClick={handleAddToCart}
            type="button"
            className="btn btn-secondary hover:btn-primary w-full is-sticky-sm items-center text-left disabled:cursor-not-allowed disabled:opacity-70"
            aria-label={`Add to Cart Button, with a total of ${accumulatedPriceRaw} dollars`}
            data-add-to-cart-btn="true"
          > 
            {loading ? "Adding" : atcLabel}
            <span className="is-sticky-price">
              {discountAmountFromCode
                ? formatPrice({
                    price: accumulatedPriceRaw - discountAmountFromCode,
                })
                : accumulatedPrice}
            </span>
          </button>
        </div>
      )}

      {!isAvailableWithPrime && !available && getRegionHandle() === "us" && (
        <KlaviyoBackInStock
          variantId={currentVariant.shopifyId}
        />
      )}

      {!availableInRegion && (
        <p role="alert">This product is not yet available in your country.</p>
      )}

      {isAvailableWithPrime && <BuyWithPrime
        SKU={`${currentVariant.sku}`}
        enabled={addedCrossSellProducts.length > 0}
      />}

      <AffirmPromotion total={accumulatedPriceRaw} type="product" />
    </div>
  )
}

export default AddToCart